import { inject, Injectable, signal } from "@angular/core"
import { Subscription, timer } from "rxjs"
import { switchMap } from "rxjs/operators"

import { lgklog } from "@logick/common/logger"
import { ServiceStatusApi } from "@logick/core-api"

const HEALTH_CHECK_INTERVAL_MS = 30_000

@Injectable({ providedIn: "root" })
export class MaintenanceService {

    private readonly serviceStatusApi = inject(ServiceStatusApi)

    private healthCheck?: Subscription

    readonly maintenance = signal(false)

    activate() {
        if (this.maintenance()) return
        lgklog.debug("[MaintenanceService]", "maintenance activée")
        this.maintenance.set(true)
        this.startHealthCheck()
    }

    private deactivate() {
        lgklog.debug("[MaintenanceService]", "maintenance terminée")
        this.maintenance.set(false)
        this.stopHealthCheck()
    }

    private startHealthCheck() {
        this.stopHealthCheck()
        this.healthCheck = timer(HEALTH_CHECK_INTERVAL_MS, HEALTH_CHECK_INTERVAL_MS)
            .pipe(switchMap(() => this.serviceStatusApi.serviceHealthReady()))
            .subscribe({
                next: () => this.deactivate(),
                error: () => this.startHealthCheck()
            })
    }

    private stopHealthCheck() {
        this.healthCheck?.unsubscribe()
        this.healthCheck = undefined
    }
}
